import React, { useContext } from 'react';

import Button from 'kingpin/atoms/Button';
import BoardContext from 'contexts/BoardContext';

const ClearQuickFiltersButton = ({
  onQuickFilterChanged,
}: {
  onQuickFilterChanged?: () => void;
}) => {
  const { selectedQuickFilters, setSelectedQuickFilters } =
    useContext(BoardContext);

  if (selectedQuickFilters.length === 0) {
    return null;
  }

  const onClearAll = () => {
    setSelectedQuickFilters([]);
    if (onQuickFilterChanged) {
      onQuickFilterChanged();
    }
  };

  return (
    <Button
      type="Ghost"
      size="Small"
      label="Clear all"
      onClick={onClearAll}
      testId="clear-quick-filters"
    />
  );
};

export default ClearQuickFiltersButton;
